// extracted by mini-css-extract-plugin
export default {"headline":"tracker-activating-modal_headline__Eum5m","image":"tracker-activating-modal_image__aJYBT","button":"tracker-activating-modal_button__e7uNy"};